/* eslint-disable jsx-a11y/iframe-has-title */
import { Button, Paragraph, Spacing, Title } from "@sicredi/react";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import { PAGE } from "#/constants";
import { useContext, useEffect } from "react";
import { ContextAPI } from "#/contextProver/ContextProver";

export const ContractDetails: React.FC = () => {
  const { vendasContrato, setIsCheckAceitoContrato } = useContext(ContextAPI);
  const navigate = useNavigate();

  const base64DataFile = vendasContrato.data
    ? vendasContrato?.data.contract
    : null;

  const handleContratarConsorcio = async () => {
    setIsCheckAceitoContrato(true);
    navigate(PAGE.CONTRATO);
  };

  useEffect(() => {
    if (!vendasContrato.data) {
      navigate(PAGE.ROOT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <Title as="h1" className={styles.title}>
        Detalhes do contrato de Consórcio
      </Title>

      <Paragraph className={styles.paragraph}>
        Confira as condições do contrato de consórcios
      </Paragraph>
      <Spacing appearance="small" />

      {base64DataFile && (
        <div className={styles.container_iframe}>
          <iframe
            src={`data:application/pdf;base64,${base64DataFile}`}
            height="100%"
            width="100%"
          ></iframe>
        </div>
      )}

      <Spacing appearance="xx-large" />
      <div className={styles.button_container}>
        <Button
          className={styles.button}
          onClick={() => navigate(-1)}
          appearance="secondary"
        >
          Voltar
        </Button>

        <Button
          className={styles.button}
          onClick={handleContratarConsorcio}
          appearance="primary"
        >
          Concluir
        </Button>
      </div>
    </div>
  );
};
